/* File Types Icons */
import AEFile from "./icons/fileTypes/ae-file-type-svgrepo-com.svg";
import AIFile from "./icons/fileTypes/ai-file-type-svgrepo-com.svg";
import AVIFile from "./icons/fileTypes/avi-file-type-svgrepo-com.svg";
import CSSFile from "./icons/fileTypes/css-file-type-svgrepo-com.svg";
import CSVFile from "./icons/fileTypes/csv-file-type-svgrepo-com.svg";
import EPSFile from "./icons/fileTypes/eps-file-type-svgrepo-com.svg";
import ExcelFile from "./icons/fileTypes/excel-file-type-svgrepo-com.svg";
import File from "./icons/fileTypes/file-file-type-svgrepo-com.svg";
import HtmlFile from "./icons/fileTypes/html-file-type-svgrepo-com.svg";
import JpgFile from "./icons/fileTypes/jpg-file-type-svgrepo-com.svg";
import MovFile from "./icons/fileTypes/mov-file-type-svgrepo-com.svg";
import Mp3File from "./icons/fileTypes/mp3-file-type-svgrepo-com.svg";
import PdfFile from "./icons/fileTypes/pdf-file-type-svgrepo-com.svg";
import PngFile from "./icons/fileTypes/png-file-type-svgrepo-com.svg";
import PptFile from "./icons/fileTypes/ppt-file-type-svgrepo-com.svg";
import PsdFile from "./icons/fileTypes/psd-file-type-svgrepo-com.svg";
import RarFile from "./icons/fileTypes/rar-file-type-svgrepo-com.svg";
import TxtFile from "./icons/fileTypes/txt-file-type-svgrepo-com.svg";
import WavFile from "./icons/fileTypes/wav-file-type-svgrepo-com.svg";
import WordFile from "./icons/fileTypes/word-file-type-svgrepo-com.svg";
import ZipFile from "./icons/fileTypes/zip-file-type-svgrepo-com.svg";
import registrationBg from "./Auth/registrationBg.png";
import ribbon from "./Auth/ribbon.png";
import logo from "./Vectors/logo.png";

export {
  AEFile,
  AIFile,
  AVIFile,
  CSSFile,
  CSVFile,
  EPSFile,
  ExcelFile,
  File,
  HtmlFile,
  JpgFile,
  MovFile,
  Mp3File,
  PdfFile,
  PngFile,
  PptFile,
  PsdFile,
  RarFile,
  TxtFile,
  WavFile,
  WordFile,
  ZipFile,
  registrationBg,
  ribbon,
  logo,
};
